import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

export function ExecuteButton({ content, onClick, disabled }) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={(
        <span className="fa-layers fa-fw fa-lg">
          <FontAwesomeIcon icon={faSave} />
          <FontAwesomeIcon icon={faCircleCheck} color="green" transform="shrink-4 down-4 right-4" />
        </span>
    )}
      onClick={onClick}
      disabled={disabled}
      title={content}
    >
      {content}
    </Button>
  );
}

ExecuteButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

ExecuteButton.defaultProps = {
  onClick: () => null,
  content: 'Провести',
  disabled: false,
};

export default ExecuteButton;
